// frontend/src/pages/OrderSuccessPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaBox } from 'react-icons/fa';

function OrderSuccessPage() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <FaCheckCircle className="text-green-500 text-6xl mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Order Placed!</h1>
        <p className="text-gray-600 mb-8">
          Thank you for your purchase. Your order has been received and is being processed. We will contact you shortly.
        </p>
        
        <div className="space-y-3">
          {/* --- FIXED LINK: Points to /account/orders now --- */}
          <Link 
            to="/account/orders" 
            className="block w-full bg-primary hover:bg-primary-dark text-white font-bold py-3 px-4 rounded-lg transition duration-300 flex items-center justify-center gap-2"
          >
            <FaBox /> View My Orders
          </Link>
          
          <Link 
            to="/parts" 
            className="block w-full bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-3 px-4 rounded-lg transition duration-300 flex items-center justify-center gap-2"
          >
            Continue Shopping <FaArrowRight />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default OrderSuccessPage;